// /src/auth/AuthCallback.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../tattoo/lib/supabaseClient";

function parseHashTokens(hash) {
  // hash looks like: #access_token=...&expires_in=...&refresh_token=...
  const h = hash.startsWith("#") ? hash.slice(1) : hash;
  const p = new URLSearchParams(h);
  const access_token = p.get("access_token");
  const refresh_token = p.get("refresh_token");
  return access_token && refresh_token ? { access_token, refresh_token } : null;
}

export default function AuthCallback() {
  const nav = useNavigate();
  const { search, hash } = useLocation();
  const [msg, setMsg] = useState("Signing you in…");

  useEffect(() => {
    (async () => {
      try {
        // 1) HASH TOKENS (implicit-style magic link)
        const tokens = parseHashTokens(hash || "");
        if (tokens) {
          // Store directly as the current session
          const { data, error } = await supabase.auth.setSession(tokens);
          if (error) throw error;
          // Clean the URL (remove the hash) & go to setup
          nav("/setup", { replace: true });
          return;
        }

        // 2) CODE + STATE (PKCE)
        const url = window.location.href;
        const hasCode = new URLSearchParams(search).has("code");
        const hasState = new URLSearchParams(search).has("state");
        if (hasCode && hasState) {
          const { data, error } = await supabase.auth.exchangeCodeForSession(url);
          if (error) throw error;
          nav("/setup", { replace: true });
          return;
        }

        // 3) CODE ONLY (older magic link style) – try anyway
        if (hasCode) {
          const { data, error } = await supabase.auth.exchangeCodeForSession(url);
          if (error) throw error;
          nav("/setup", { replace: true });
          return;
        }

        // If we got here, nothing usable was in the URL.
        setMsg("Could not sign you in. Please request a new link.");
      } catch (err) {
        console.error("[callback] auth failed:", err);
        setMsg("Could not sign you in. Please request a new link.");
      }
    })();
  }, [hash, search, nav]);

  return (
    <div style={{ padding: 24, color: "#ddd" }}>
      <h2>{msg}</h2>
      <div style={{ opacity: 0.7, fontSize: 12, marginTop: 12 }}>
        Debug URL:<br />{window.location.href}
      </div>
    </div>
  );
}